import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Protocol17025Cat_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Cat_Interface';
import { Protocol17025ChartFile_Interface } from 'src/app/Interface/Protocol17025/Protocol17025ChartFile_Interface';
import { Protocol17025Chart_Interface } from 'src/app/Interface/Protocol17025/Protocol17025Chart_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { Protocol17025ChartFileService } from 'src/app/Service/Protocol17025/Protocol17025ChartFile.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-Protocol17025View',
  templateUrl: './Protocol17025View.component.html',
  styleUrls: ['./Protocol17025View.component.scss']
})
export class Protocol17025ViewComponent implements OnInit {

  Token: String = ""
  BaseUrl = environment.BaseUrl
  Procssing:boolean=false

  /*
  Selected_Chart_View = 0 ; General
  Selected_Chart_View = 1 ; Device Behfa
  Selected_Chart_View = 2 ; Handling
  Selected_Chart_View = 3 ; Request

  */

  Selected_Chart_Id: number = 0
  Selected_Chart_View:number = 0
  Selected_Chart_Level: General_Interface = Empty_General_Interface()
  StartSearchDate:string="1390-01-01"
  EndSearchDate:string="1415-01-01"
  SubmitPeriodDate: string = "1"

  Chat_Id_Filter=''
  Chat_Id_Filter_Main=''
  page_File:number=0

  Child_Form_DataList:Array<Protocol17025Chart_Interface>=[]
  Child_Protocol_DataList: Array<Protocol17025Chart_Interface> = []

  File_DataList:Array<Protocol17025ChartFile_Interface>=[]


  constructor(
    private Protocol17025ChartFile_Service:Protocol17025ChartFileService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,2173).subscribe(
      data=>{
        this.GetTag_List()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }



  //#region View

  form_search_txt: string = ''

  OnSetChat_Id(id: number)
  {

    if (Number(this.Chat_Id_Filter) == id)
      this.Chat_Id_Filter=''
    else
      this.Chat_Id_Filter = id + ''

    //if (this.Selected_Chart_View==0)
      this.Chat_Id_Filter_Main=this.Chat_Id_Filter
  }

  OnGet_Chat_Id() {
    if(this.Chat_Id_Filter)
      return Number(this.Chat_Id_Filter)
    else
      return 0
  }

  OnSetView(id: number,view:number)
  {
    this.Selected_Chart_View=view
    this.Selected_Chart_Id = id
    this.Selected_Chart_Level.id = id

    this.Selected_Tag=[]
    this.txt_Search=''
    this.GetTag_List()
    //
  }

  OnSetDate_ReadView(StartSearchDate, EndSearchDate)
  {
    this.StartSearchDate=StartSearchDate
    this.EndSearchDate = EndSearchDate
    this.OnReadView()
  }

  OnReadView() {
    this.Chat_Id_Filter=''
    this.Procssing = true

    if(this.modalRef_Search)
      this.modalRef_Search.hide()

    var Selected_Tag_ids:Array<number>=[]
    for (let item of this.Selected_Tag)
    {
      Selected_Tag_ids.push(item.id)
    }

    this.Child_Form_DataList=[]
    this.Child_Protocol_DataList = []
    this.File_DataList = []

    this.Protocol17025ChartFile_Service.GetView(this.Token,
      this.txt_Search,
      this.StartSearchDate,
      this.EndSearchDate,
      this.SubmitPeriodDate,
      this.Selected_Chart_Id,
      this.Selected_Chart_View,
      Selected_Tag_ids).subscribe(
      data => {

        this.Selected_Chart_Level.title = data['model']['title']
        this.Selected_Chart_Level.code = data['model']['code']
        this.Selected_Chart_Level.id = data['model']['id']

        this.Child_Form_DataList=data['catChild_Form']
        this.Child_Protocol_DataList = data['catChild_Protocol']

        this.File_DataList = data['file']
        this.page_File=0
        this.Procssing=false
      },
    )
  }

  OnBack() {
    this.Selected_Chart_Level=Empty_General_Interface()
  }

  OnBack_Protocol() {
    this.Chat_Id_Filter=''
  }

  //#endregion

  //#region Search

  GetTag_List()
  {
    this.Protocol17025ChartFile_Service.GetSingle(this.Token, 0).subscribe(
      data => {
        this.DataList_Protocol17025Cat = data['tag']
        this.OnReadView()
      },
      error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  modalRef_Search: any;
  openModal_Search(template: TemplateRef<any>) {
    this.modalRef_Search = this.modalService.show(template);
  }

  txt_Search:string=''

  Selected_Tag: Array<Protocol17025Cat_Interface> = []
  DataList_Protocol17025Cat: Array<Protocol17025Cat_Interface> = []

  OnGet_Selected_Tag(item: Array<Protocol17025Cat_Interface>)
  {
    this.Selected_Tag = item
  }

  //#endregion

}
